import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      text: "My mother in law Sou. Sarayu Naik A/P Vengurla, aged 88 yrs. was suffering from a tumour inside her mouth and throat due for last 12 years. The tumour was so overgrown that she could neither breath easily nor take solid food from her mouth. Fortunately, we met to an angel, who removed the tumour by a successful operation. Now the patient is enjoying her life happily. The name of the angel is the eminent surgeon Dr. Adesh Palyekar. We are thankful and always owe to him for the rebirth given to my mother in law.",
      author: "Seema Naik",
      googleReviewUrl: "https://g.co/kgs/jBvgtk8"
    },
    {
      text: "My mother diagnosed with breast cancer, and we were really afraid a alot. But Dr Palyekar provided proper guidance and given direction for further treatment. His treatment is outstanding, moreover, he also explained everything about cancer ,it's treatment, root cause, tests, etc. We really wish him and his team best of luck for their future advancement",
      author: "Jesika Fernandes",
      googleReviewUrl: "https://g.co/kgs/2PPcJnd"
    },
    {
      text: "Wonderful experience with Konkan Cancer Centre. Dr. Adesh Palyekar is a wonderful surgeon. He explained everything to us in a very clear manner and maintained required transparency. He ensured we had a smooth surgery, and follow-up. I am so glad we found Konkan Cancer Centre locally (500 km away from Mumbai) and would highly recommend to anyone. He also kind and friendly. All of the staff members were great, helpful, patient and assisted with all my insurance requirements",
      author: "Pramod Bhirvandekar",
      googleReviewUrl: "https://g.co/kgs/XvciSct"
    }
  ];

  // Star rating component
  const StarRating = () => (
    <div className="flex items-center gap-1 mb-4">
      {[...Array(5)].map((_, i) => (
        <i 
          key={i} 
          className="fas fa-star text-gold-500 text-xl"
          aria-label={`Star ${i + 1} of 5`}
        ></i>
      ))}
      <span className="ml-2 text-sm font-accent font-semibold text-gold-600">
        5.0 Rating
      </span>
    </div>
  );

  return (
    <section id="testimonials" className="section bg-background">
      <div className="container">
        <h2 className="section-title">Patient Testimonials</h2>
        
        <div className="max-w-4xl mx-auto space-y-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="card p-8 border-l-4 border-accent-500 hover:shadow-premium-lg transition-all duration-300">
              {/* Star Rating */}
              <StarRating />
              
              <p className="text-lg text-text-muted italic mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>
              
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center">
                    <i className="fas fa-user text-white text-lg"></i>
                  </div>
                  <div>
                    <span className="font-accent font-bold text-primary-700 block">
                      {testimonial.author}
                    </span>
                    <span className="text-sm text-text-muted">
                      Verified Patient
                    </span>
                  </div>
                </div>
                
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                  <div className="flex items-center gap-2 text-sm text-text-muted">
                    <i className="fas fa-check-circle text-medical-500"></i>
                    <span>Verified Review</span>
                  </div>
                  
                  <a 
                    href={testimonial.googleReviewUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-primary-500 to-accent-500 text-white text-sm font-accent font-semibold rounded-lg hover:from-primary-600 hover:to-accent-600 transition-all duration-300 transform hover:-translate-y-0.5 shadow-premium hover:shadow-premium-lg w-full sm:w-auto justify-center"
                  >
                    <i className="fab fa-google text-white"></i>
                    View on Google
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Overall Rating Summary */}
        <div className="mt-12 text-center">
          <div className="card-glass p-8 max-w-2xl mx-auto">
            <div className="flex items-center justify-center gap-4 mb-4">
              <div className="flex items-center gap-2">
                {[...Array(5)].map((_, i) => (
                  <i 
                    key={i} 
                    className="fas fa-star text-gold-500 text-2xl"
                    aria-label={`Star ${i + 1} of 5`}
                  ></i>
                ))}
              </div>
              <div className="text-left">
                <div className="font-display text-3xl font-bold text-primary-700">
                  5.0
                </div>
                <div className="text-sm text-text-muted">
                  Average Rating
                </div>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div className="text-center">
                <div className="font-accent font-bold text-primary-700">100%</div>
                <div className="text-text-muted">Satisfaction</div>
              </div>
              <div className="text-center">
                <div className="font-accent font-bold text-primary-700">500+</div>
                <div className="text-text-muted">Patients Treated</div>
              </div>
            </div>
            
            <div className="mt-6">
              <a 
                href="https://www.google.com/search?sca_esv=db574b12b5cc4f7e&cs=0&sxsrf=AE3TifN74z47mQhXCsE9LqwK8dMwcBbpVw:1753719525120&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E2B-uOTYkN_qTMi1pjiM421nsaednoPTVaaTjPaVJDybE6R285a-7TsB4qnqlPg0AiZO46bAW1aDKbVfiqnN1BQtjWxL0l2i322N-ED4RqpFYhyRAKOYQ7XTr2s5uZvjjzFMqe4%3D&q=Konkan+Cancer+and+Multispeciality+Hospital+Reviews&sa=X&ved=2ahUKEwiek9Kq-t-OAxVHk2oFHQOqCdIQ0bkNegQIIhAD&biw=1396&bih=719&dpr=2.2"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-gold-500 to-gold-600 text-white font-accent font-semibold rounded-xl hover:from-gold-600 hover:to-gold-700 transition-all duration-300 transform hover:-translate-y-1 shadow-gold hover:shadow-gold-lg"
              >
                <i className="fab fa-google text-white text-lg"></i>
                Read All Google Reviews
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 